export function brand(state) {
  return state.brand;
}
